export default __webpack_public_path__ + "static/media/IconTaskAlert.6f08cf46.svg";